// extracted by mini-css-extract-plugin
export default {"App":"main_App__UaHbo","App-logo":"main_App-logo__bwOm5","App-logo-spin":"main_App-logo-spin__mo1hV","App-header":"main_App-header__D3lSH","App-link":"main_App-link__GTEqB"};